import * as React from "react";
import {
  ETheme,
  Hamburger,
  makeStyles,
  NavCategory,
  NavCategoryItem,
  NavDrawer,
  NavDrawerBody,
  NavDrawerHeader,
  NavItem,
  NavSubItem,
  NavSubItemGroup,
  Tooltip,
} from "@/DependenciesV9";
import {
  Board20Filled,
  Board20Regular,
  bundleIcon,
  NotePin20Filled,
  NotePin20Regular,
} from "@fluentui/react-icons";
import { useSelector } from "react-redux";
import { RootState } from "@/redux";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  nav: {
    width: "280px",
  },
  navMobile: {
    width: "60px",
  },
  headerNav: {
    borderBottom: "1px solid rgb(234, 234, 234)",
    height: "44px",
  },
});

const Dashboard = bundleIcon(Board20Filled, Board20Regular);
const JobPostings = bundleIcon(NotePin20Filled, NotePin20Regular);

const SideBar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const styles = useStyles();
  const [isOpen, setIsOpen] = React.useState(true);
  const [workingPage, setWorkingPage] = useState<{
    parent: string;
    id: string;
  }>({
    parent: "",
    id: "tenants",
  });
  const theme: ETheme = useSelector(
    (state: RootState) => state.settingInfo?.theme || ETheme.Light,
  );
  const workingTenant = useSelector(
    (state: RootState) => state.settingInfo?.workingTenant,
  );

  useEffect(() => {
    console.log("location.pathname", location.pathname);
    updateWorkingPage(mapValueFromPathName(location.pathname));
  }, [location.pathname]);

  const mapValueFromPathName = (pathName: string): string => {
    if (pathName.includes("organizations")) {
      return "organizations";
    } else if (pathName.includes("locations")) {
      return "locations";
    } else if (pathName.includes("categories")) {
      return "categories";
    } else if (pathName.includes("tenants")) {
      return "tenants";
    }
    return "";
  };

  const navigateTo = (value: string) => {
    switch (value) {
      case "organizations":
        navigate(`/${workingTenant}/organizations`);
        break;
      case "locations":
        navigate(`/${workingTenant}/locations`);
        break;
      case "categories":
        navigate(`/${workingTenant}/categories`);
        break;
      case "tenants":
        navigate(`/${workingTenant}/tenants`);
        break;
      default:
        break;
    }
  };

  const updateWorkingPage = (value: string) => {
    switch (value) {
      case "organizations":
        setWorkingPage({
          parent: "organization_management",
          id: value,
        });
        break;
      case "locations":
        setWorkingPage({
          parent: "organization_management",
          id: value,
        });
        break;
      case "categories":
        setWorkingPage({
          parent: "organization_management",
          id: value,
        });
        break;
      case "tenants":
        setWorkingPage({
          parent: "",
          id: value,
        });
        break;
      default:
        break;
    }
  };

  return (
    <>
      {isOpen ? (
        <NavDrawer
          // @ts-ignore
          selectedValue={workingPage.id}
          selectedCategoryValue={workingPage.parent}
          open={true}
          type={"inline"}
          multiple={false}
          className={styles.nav}
          theme={theme}
        >
          <NavDrawerHeader className={styles.headerNav}>
            <Tooltip content="Close Navigation" relationship="label">
              <Hamburger onClick={() => setIsOpen(!isOpen)} />
            </Tooltip>
          </NavDrawerHeader>

          <NavDrawerBody>
            <NavCategory value="organization_management">
              <NavCategoryItem
                icon={<JobPostings />}
              >
                Organization Management
              </NavCategoryItem>
              <NavSubItemGroup>
                <NavSubItem
                  value="organizations"
                  onClick={() => navigateTo("organizations")}
                >
                  Organizations
                </NavSubItem>
                <NavSubItem
                  value="locations"
                  onClick={() => navigateTo("locations")}
                >
                  Locations
                </NavSubItem>
                <NavSubItem
                  value="categories"
                  onClick={() => navigateTo("categories")}
                >
                  Categories
                </NavSubItem>
              </NavSubItemGroup>
            </NavCategory>
            <NavItem
              icon={<Dashboard />}
              value="tenants"
              onClick={() => navigateTo("tenants")}
            >
              Tenant Management
            </NavItem>
          </NavDrawerBody>
        </NavDrawer>
      ) : (
        <NavDrawer
          defaultSelectedValue="2"
          defaultSelectedCategoryValue="2"
          open={true}
          type={"inline"}
          multiple={false}
          className={styles.navMobile}
          theme={theme || ETheme.Light}
        >
          <NavDrawerHeader className={styles.headerNav}>
            <Tooltip content="Close Navigation" relationship="label">
              <Hamburger onClick={() => setIsOpen(!isOpen)} />
            </Tooltip>
          </NavDrawerHeader>

          <NavDrawerBody>
            <NavItem icon={<Dashboard />} value="2"></NavItem>
          </NavDrawerBody>
        </NavDrawer>
      )}
    </>
  );
};

export default SideBar;
